import { CVData } from '../types';
import ejecutivo from './ejecutivo';
import conferencias from './conferencias';

/**
 * Modo "Conferenciante": la trayectoria es la del modo ejecutivo; cambian el
 * hero, el perfil, las cifras y el contacto, y se añaden las conferencias.
 */
const conferenciante: CVData = {
  ...ejecutivo,

  profileStatement: {
    es: 'Conferenciante y autor de El arte de preguntar (Espasa, 2026). Llevo al escenario dos keynotes con una misma convicción: cuando las respuestas sobran, lo que marca la diferencia son las buenas preguntas y las obras que se construyen sin prisa. Hablo desde más de 30 años de trayectoria como Ingeniero Industrial y directivo: CEO en tres sectores distintos, director de la transformación digital del Gobierno de La Rioja con 300 personas a mi cargo, impulsor de 9 spin-offs universitarios y fundador de productos propios de inteligencia artificial como Kairos Governance y Teselia. Para educadores, líderes, padres, equipos y organizaciones que quieren salir de la sala pensando distinto.',
    en: 'Keynote speaker and author of El arte de preguntar (The Art of Asking, Espasa, 2026). I take two keynotes to the stage, sharing one conviction: when answers are everywhere, what makes the difference is good questions and the work that is built without hurry. I speak from more than 30 years as an Industrial Engineer and executive: CEO in three different sectors, head of the digital transformation of the Government of La Rioja with 300 people in my team, driver of 9 university spin-offs and founder of in-house AI products such as Kairos Governance and Teselia. For educators, leaders, parents, teams and organisations who want to leave the room thinking differently.',
  },

  heroTagline: {
    es: 'Keynotes · Autor · Transformación e IA',
    en: 'Keynotes · Author · Transformation & AI',
  },

  heroCTA: {
    es: 'Descargar perfil',
    en: 'Download speaker profile',
  },

  stats: [
    { value: '2', label: { es: 'Conferencias', en: 'Keynotes' } },
    { value: '2', label: { es: 'Libros publicados', en: 'Books published' } },
    { value: '30+', label: { es: 'Años de carrera ejecutiva', en: 'Years executive career' } },
    { value: '9', label: { es: 'Spin-offs lanzados', en: 'Spin-offs launched' } },
  ],

  contactCTA: {
    es: 'Llevemos estas ideas a tu equipo',
    en: "Let's bring these ideas to your team",
  },

  talks: conferencias,
};

export default conferenciante;
